// extracted by mini-css-extract-plugin
module.exports = {"readerView":"ReaderView_readerView__1DZqg","readerContainer":"ReaderView_readerContainer__86exJ"};